class y extends Error {
  errorCode;
  /**
   * Constructor.
   *
   * @param errorCode Defined by the user of this error, but must match the regexp: [0-9a-z]{1,5}
   */
  constructor(r, t) {
    super(r, t), Object.setPrototypeOf(this, y.prototype), Error.captureStackTrace && Error.captureStackTrace(this, y), this.name = "TidalError", this.errorCode = r;
  }
}
class m extends y {
  constructor(r, t) {
    super(r, t), Object.setPrototypeOf(this, m.prototype), Error.captureStackTrace && Error.captureStackTrace(this, m), this.name = "IllegalArgumentError";
  }
}
let R = !1;
class _ extends y {
  constructor(r, t) {
    super(r, t), Object.setPrototypeOf(this, _.prototype), Error.captureStackTrace && Error.captureStackTrace(this, _), this.name = "OutageStartError";
  }
}
const W = {
  name: "OutageEndMessage"
}, T = (e) => {
  R !== e && (R = e, D(e ? new _("1") : W));
}, q = () => R, $ = (e) => globalThis.addEventListener(
  "eventProducerEventBus",
  e
), D = (e) => {
  const r = new CustomEvent("eventProducerEventBus", {
    detail: e
  });
  globalThis.dispatchEvent(r);
}, pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bus: $,
  postMessage: D
}, Symbol.toStringTag, { value: "Module" }));
let g;
const V = (e) => {
  g = e;
}, ye = (e) => {
  g.credentialsProvider = e;
}, me = (e) => {
  g.blockedConsentCategories = {
    ...g.blockedConsentCategories,
    ...e
  };
}, S = () => g;
class K {
  #e;
  #r = !1;
  #t;
  #n;
  constructor(r) {
    this.#n = new URL(r), this.synchronize();
  }
  /**
   * Returns the current time adjusted to server-time.
   *
   * @param clientCurrentTime The current time on the client side. Defaults to Date.now().
   * @returns The current adjusted time (or the client time if not synced yet).
   */
  // eslint-disable-next-line no-restricted-syntax
  now(r = Date.now()) {
    return !this.#t || !this.#e ? (console.warn("TrueTime is not yet synchronized"), r) : this.#t + (r - this.#e);
  }
  /**
   * Synchronizes the client's time with the server's time.
   * If the client's time is already synchronized within an hour, this method does nothing.
   *
   * @returns {Promise<void>} A promise that resolves when the synchronization is complete.
   */
  async synchronize() {
    if (!(this.#e && // eslint-disable-next-line no-restricted-syntax
    Math.abs(Date.now() - this.#e) < 36e5 || this.#r)) {
      this.#r = !0;
      try {
        const r = await fetch(this.#n);
        r.ok && r.headers.has("date") && (this.#t = new Date(r.headers.get("date")).getTime(), this.#e = Date.now());
      } catch (r) {
        console.error(r);
      }
      this.#r = !1;
    }
  }
  /**
   * Returns the timestamp of a performance mark with the specified name and detail.
   * PS: `performance.mark` must be called with `startTime: trueTime.now()`.
   *
   * @param markName - The name of the performance mark.
   * @param detail - Optional. The detail of the performance mark.
   * @returns The timestamp of the performance mark, or undefined if not found.
   * @throws ReferenceError if the performance mark is not found.
   */
  timestamp(r, t) {
    let n;
    if (t) {
      if (n = performance.getEntriesByName(r).find((o) => "detail" in o && o.detail === t), !n)
        throw new ReferenceError(
          `There is no performance entry named "${r}" with detail "${t}"`
        );
    } else
      n = performance.getEntriesByName(r).pop();
    return n ? n.startTime : void 0;
  }
}
const O = new K("https://api.tidal.com/v1/ping"), B = `var oe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $r(L) {
  return L && L.__esModule && Object.prototype.hasOwnProperty.call(L, "default") ? L.default : L;
}
function ae(L) {
  throw new Error('Could not dynamically require "' + L + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pe = { exports: {} };
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
var ze;
function Vr() {
  return ze || (ze = 1, function(L, X) {
    (function(P) {
      L.exports = P();
    })(function() {
      return function P(Y, Q, E) {
        function C(T, z) {
          if (!Q[T]) {
            if (!Y[T]) {
              var v = typeof ae == "function" && ae;
              if (!z && v) return v(T, !0);
              if (b) return b(T, !0);
              var h = new Error("Cannot find module '" + T + "'");
              throw h.code = "MODULE_NOT_FOUND", h;
            }
            var I = Q[T] = { exports: {} };
            Y[T][0].call(I.exports, function(A) {
              var W = Y[T][1][A];
              return C(W || A);
            }, I, I.exports, P, Y, Q, E);
          }
          return Q[T].exports;
        }
        for (var b = typeof ae == "function" && ae, B = 0; B < E.length; B++) C(E[B]);
        return C;
      }({ 1: [function(P, Y, Q) {
        (function(E) {
          var C = E.MutationObserver || E.WebKitMutationObserver, b;
          if (C) {
            var B = 0, T = new C(A), z = E.document.createTextNode("");
            T.observe(z, {
              characterData: !0
            }), b = function() {
              z.data = B = ++B % 2;
            };
          } else if (!E.setImmediate && typeof E.MessageChannel < "u") {
            var v = new E.MessageChannel();
            v.port1.onmessage = A, b = function() {
              v.port2.postMessage(0);
            };
          } else "document" in E && "onreadystatechange" in E.document.createElement("script") ? b = function() {
            var D = E.document.createElement("script");
            D.onreadystatechange = function() {
              A(), D.onreadystatechange = null, D.parentNode.removeChild(D), D = null;
            }, E.document.documentElement.appendChild(D);
          } : b = function() {
            setTimeout(A, 0);
          };
          var h, I = [];
          function A() {
            h = !0;
            for (var D, $, N = I.length; N; ) {
              for ($ = I, I = [], D = -1; ++D < N; )
                $[D]();
              N = I.length;
            }
            h = !1;
          }
          Y.exports = W;
          function W(D) {
            I.push(D) === 1 && !h && b();
          }
        }).call(this, typeof oe < "u" ? oe : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, {}], 2: [function(P, Y, Q) {
        var E = P(1);
        function C() {
        }
        var b = {}, B = ["REJECTED"], T = ["FULFILLED"], z = ["PENDING"];
        Y.exports = v;
        function v(l) {
          if (typeof l != "function")
            throw new TypeError("resolver must be a function");
          this.state = z, this.queue = [], this.outcome = void 0, l !== C && W(this, l);
        }
        v.prototype.catch = function(l) {
          return this.then(null, l);
        }, v.prototype.then = function(l, p) {
          if (typeof l != "function" && this.state === T || typeof p != "function" && this.state === B)
            return this;
          var y = new this.constructor(C);
          if (this.state !== z) {
            var w = this.state === T ? l : p;
            I(y, w, this.outcome);
          } else
            this.queue.push(new h(y, l, p));
          return y;
        };
        function h(l, p, y) {
          this.promise = l, typeof p == "function" && (this.onFulfilled = p, this.callFulfilled = this.otherCallFulfilled), typeof y == "function" && (this.onRejected = y, this.callRejected = this.otherCallRejected);
        }
        h.prototype.callFulfilled = function(l) {
          b.resolve(this.promise, l);
        }, h.prototype.otherCallFulfilled = function(l) {
          I(this.promise, this.onFulfilled, l);
        }, h.prototype.callRejected = function(l) {
          b.reject(this.promise, l);
        }, h.prototype.otherCallRejected = function(l) {
          I(this.promise, this.onRejected, l);
        };
        function I(l, p, y) {
          E(function() {
            var w;
            try {
              w = p(y);
            } catch (x) {
              return b.reject(l, x);
            }
            w === l ? b.reject(l, new TypeError("Cannot resolve promise with itself")) : b.resolve(l, w);
          });
        }
        b.resolve = function(l, p) {
          var y = D(A, p);
          if (y.status === "error")
            return b.reject(l, y.value);
          var w = y.value;
          if (w)
            W(l, w);
          else {
            l.state = T, l.outcome = p;
            for (var x = -1, O = l.queue.length; ++x < O; )
              l.queue[x].callFulfilled(p);
          }
          return l;
        }, b.reject = function(l, p) {
          l.state = B, l.outcome = p;
          for (var y = -1, w = l.queue.length; ++y < w; )
            l.queue[y].callRejected(p);
          return l;
        };
        function A(l) {
          var p = l && l.then;
          if (l && (typeof l == "object" || typeof l == "function") && typeof p == "function")
            return function() {
              p.apply(l, arguments);
            };
        }
        function W(l, p) {
          var y = !1;
          function w(M) {
            y || (y = !0, b.reject(l, M));
          }
          function x(M) {
            y || (y = !0, b.resolve(l, M));
          }
          function O() {
            p(x, w);
          }
          var F = D(O);
          F.status === "error" && w(F.value);
        }
        function D(l, p) {
          var y = {};
          try {
            y.value = l(p), y.status = "success";
          } catch (w) {
            y.status = "error", y.value = w;
          }
          return y;
        }
        v.resolve = $;
        function $(l) {
          return l instanceof this ? l : b.resolve(new this(C), l);
        }
        v.reject = N;
        function N(l) {
          var p = new this(C);
          return b.reject(p, l);
        }
        v.all = ie;
        function ie(l) {
          var p = this;
          if (Object.prototype.toString.call(l) !== "[object Array]")
            return this.reject(new TypeError("must be an array"));
          var y = l.length, w = !1;
          if (!y)
            return this.resolve([]);
          for (var x = new Array(y), O = 0, F = -1, M = new this(C); ++F < y; )
            V(l[F], F);
          return M;
          function V(Z, re) {
            p.resolve(Z).then(fe, function(J) {
              w || (w = !0, b.reject(M, J));
            });
            function fe(J) {
              x[re] = J, ++O === y && !w && (w = !0, b.resolve(M, x));
            }
          }
        }
        v.race = j;
        function j(l) {
          var p = this;
          if (Object.prototype.toString.call(l) !== "[object Array]")
            return this.reject(new TypeError("must be an array"));
          var y = l.length, w = !1;
          if (!y)
            return this.resolve([]);
          for (var x = -1, O = new this(C); ++x < y; )
            F(l[x]);
          return O;
          function F(M) {
            p.resolve(M).then(function(V) {
              w || (w = !0, b.resolve(O, V));
            }, function(V) {
              w || (w = !0, b.reject(O, V));
            });
          }
        }
      }, { 1: 1 }], 3: [function(P, Y, Q) {
        (function(E) {
          typeof E.Promise != "function" && (E.Promise = P(2));
        }).call(this, typeof oe < "u" ? oe : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, { 2: 2 }], 4: [function(P, Y, Q) {
        var E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
          return typeof e;
        } : function(e) {
          return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        };
        function C(e, n) {
          if (!(e instanceof n))
            throw new TypeError("Cannot call a class as a function");
        }
        function b() {
          try {
            if (typeof indexedDB < "u")
              return indexedDB;
            if (typeof webkitIndexedDB < "u")
              return webkitIndexedDB;
            if (typeof mozIndexedDB < "u")
              return mozIndexedDB;
            if (typeof OIndexedDB < "u")
              return OIndexedDB;
            if (typeof msIndexedDB < "u")
              return msIndexedDB;
          } catch {
            return;
          }
        }
        var B = b();
        function T() {
          try {
            if (!B || !B.open)
              return !1;
            var e = typeof openDatabase < "u" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform), n = typeof fetch == "function" && fetch.toString().indexOf("[native code") !== -1;
            return (!e || n) && typeof indexedDB < "u" && // some outdated implementations of IDB that appear on Samsung
            // and HTC Android devices <4.4 are missing IDBKeyRange
            // See: https://github.com/mozilla/localForage/issues/128
            // See: https://github.com/mozilla/localForage/issues/272
            typeof IDBKeyRange < "u";
          } catch {
            return !1;
          }
        }
        function z(e, n) {
          e = e || [], n = n || {};
          try {
            return new Blob(e, n);
          } catch (t) {
            if (t.name !== "TypeError")
              throw t;
            for (var r = typeof BlobBuilder < "u" ? BlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" ? MozBlobBuilder : WebKitBlobBuilder, o = new r(), a = 0; a < e.length; a += 1)
              o.append(e[a]);
            return o.getBlob(n.type);
          }
        }
        typeof Promise > "u" && P(3);
        var v = Promise;
        function h(e, n) {
          n && e.then(function(r) {
            n(null, r);
          }, function(r) {
            n(r);
          });
        }
        function I(e, n, r) {
          typeof n == "function" && e.then(n), typeof r == "function" && e.catch(r);
        }
        function A(e) {
          return typeof e != "string" && (console.warn(e + " used as a key, but it is not a string."), e = String(e)), e;
        }
        function W() {
          if (arguments.length && typeof arguments[arguments.length - 1] == "function")
            return arguments[arguments.length - 1];
        }
        var D = "local-forage-detect-blob-support", $ = void 0, N = {}, ie = Object.prototype.toString, j = "readonly", l = "readwrite";
        function p(e) {
          for (var n = e.length, r = new ArrayBuffer(n), o = new Uint8Array(r), a = 0; a < n; a++)
            o[a] = e.charCodeAt(a);
          return r;
        }
        function y(e) {
          return new v(function(n) {
            var r = e.transaction(D, l), o = z([""]);
            r.objectStore(D).put(o, "key"), r.onabort = function(a) {
              a.preventDefault(), a.stopPropagation(), n(!1);
            }, r.oncomplete = function() {
              var a = navigator.userAgent.match(/Chrome\\/(\\d+)/), t = navigator.userAgent.match(/Edge\\//);
              n(t || !a || parseInt(a[1], 10) >= 43);
            };
          }).catch(function() {
            return !1;
          });
        }
        function w(e) {
          return typeof $ == "boolean" ? v.resolve($) : y(e).then(function(n) {
            return $ = n, $;
          });
        }
        function x(e) {
          var n = N[e.name], r = {};
          r.promise = new v(function(o, a) {
            r.resolve = o, r.reject = a;
          }), n.deferredOperations.push(r), n.dbReady ? n.dbReady = n.dbReady.then(function() {
            return r.promise;
          }) : n.dbReady = r.promise;
        }
        function O(e) {
          var n = N[e.name], r = n.deferredOperations.pop();
          if (r)
            return r.resolve(), r.promise;
        }
        function F(e, n) {
          var r = N[e.name], o = r.deferredOperations.pop();
          if (o)
            return o.reject(n), o.promise;
        }
        function M(e, n) {
          return new v(function(r, o) {
            if (N[e.name] = N[e.name] || be(), e.db)
              if (n)
                x(e), e.db.close();
              else
                return r(e.db);
            var a = [e.name];
            n && a.push(e.version);
            var t = B.open.apply(B, a);
            n && (t.onupgradeneeded = function(i) {
              var f = t.result;
              try {
                f.createObjectStore(e.storeName), i.oldVersion <= 1 && f.createObjectStore(D);
              } catch (u) {
                if (u.name === "ConstraintError")
                  console.warn('The database "' + e.name + '" has been upgraded from version ' + i.oldVersion + " to version " + i.newVersion + ', but the storage "' + e.storeName + '" already exists.');
                else
                  throw u;
              }
            }), t.onerror = function(i) {
              i.preventDefault(), o(t.error);
            }, t.onsuccess = function() {
              var i = t.result;
              i.onversionchange = function(f) {
                f.target.close();
              }, r(i), O(e);
            };
          });
        }
        function V(e) {
          return M(e, !1);
        }
        function Z(e) {
          return M(e, !0);
        }
        function re(e, n) {
          if (!e.db)
            return !0;
          var r = !e.db.objectStoreNames.contains(e.storeName), o = e.version < e.db.version, a = e.version > e.db.version;
          if (o && (e.version !== n && console.warn('The database "' + e.name + \`" can't be downgraded from version \` + e.db.version + " to version " + e.version + "."), e.version = e.db.version), a || r) {
            if (r) {
              var t = e.db.version + 1;
              t > e.version && (e.version = t);
            }
            return !0;
          }
          return !1;
        }
        function fe(e) {
          return new v(function(n, r) {
            var o = new FileReader();
            o.onerror = r, o.onloadend = function(a) {
              var t = btoa(a.target.result || "");
              n({
                __local_forage_encoded_blob: !0,
                data: t,
                type: e.type
              });
            }, o.readAsBinaryString(e);
          });
        }
        function J(e) {
          var n = p(atob(e.data));
          return z([n], { type: e.type });
        }
        function _e(e) {
          return e && e.__local_forage_encoded_blob;
        }
        function Ve(e) {
          var n = this, r = n._initReady().then(function() {
            var o = N[n._dbInfo.name];
            if (o && o.dbReady)
              return o.dbReady;
          });
          return I(r, e, e), r;
        }
        function Ke(e) {
          x(e);
          for (var n = N[e.name], r = n.forages, o = 0; o < r.length; o++) {
            var a = r[o];
            a._dbInfo.db && (a._dbInfo.db.close(), a._dbInfo.db = null);
          }
          return e.db = null, V(e).then(function(t) {
            return e.db = t, re(e) ? Z(e) : t;
          }).then(function(t) {
            e.db = n.db = t;
            for (var i = 0; i < r.length; i++)
              r[i]._dbInfo.db = t;
          }).catch(function(t) {
            throw F(e, t), t;
          });
        }
        function K(e, n, r, o) {
          o === void 0 && (o = 1);
          try {
            var a = e.db.transaction(e.storeName, n);
            r(null, a);
          } catch (t) {
            if (o > 0 && (!e.db || t.name === "InvalidStateError" || t.name === "NotFoundError"))
              return v.resolve().then(function() {
                if (!e.db || t.name === "NotFoundError" && !e.db.objectStoreNames.contains(e.storeName) && e.version <= e.db.version)
                  return e.db && (e.version = e.db.version + 1), Z(e);
              }).then(function() {
                return Ke(e).then(function() {
                  K(e, n, r, o - 1);
                });
              }).catch(r);
            r(t);
          }
        }
        function be() {
          return {
            // Running localForages sharing a database.
            forages: [],
            // Shared database.
            db: null,
            // Database readiness (promise).
            dbReady: null,
            // Deferred operations on the database.
            deferredOperations: []
          };
        }
        function Qe(e) {
          var n = this, r = {
            db: null
          };
          if (e)
            for (var o in e)
              r[o] = e[o];
          var a = N[r.name];
          a || (a = be(), N[r.name] = a), a.forages.push(n), n._initReady || (n._initReady = n.ready, n.ready = Ve);
          var t = [];
          function i() {
            return v.resolve();
          }
          for (var f = 0; f < a.forages.length; f++) {
            var u = a.forages[f];
            u !== n && t.push(u._initReady().catch(i));
          }
          var s = a.forages.slice(0);
          return v.all(t).then(function() {
            return r.db = a.db, V(r);
          }).then(function(c) {
            return r.db = c, re(r, n._defaultConfig.version) ? Z(r) : c;
          }).then(function(c) {
            r.db = a.db = c, n._dbInfo = r;
            for (var d = 0; d < s.length; d++) {
              var m = s[d];
              m !== n && (m._dbInfo.db = r.db, m._dbInfo.version = r.version);
            }
          });
        }
        function Ge(e, n) {
          var r = this;
          e = A(e);
          var o = new v(function(a, t) {
            r.ready().then(function() {
              K(r._dbInfo, j, function(i, f) {
                if (i)
                  return t(i);
                try {
                  var u = f.objectStore(r._dbInfo.storeName), s = u.get(e);
                  s.onsuccess = function() {
                    var c = s.result;
                    c === void 0 && (c = null), _e(c) && (c = J(c)), a(c);
                  }, s.onerror = function() {
                    t(s.error);
                  };
                } catch (c) {
                  t(c);
                }
              });
            }).catch(t);
          });
          return h(o, n), o;
        }
        function He(e, n) {
          var r = this, o = new v(function(a, t) {
            r.ready().then(function() {
              K(r._dbInfo, j, function(i, f) {
                if (i)
                  return t(i);
                try {
                  var u = f.objectStore(r._dbInfo.storeName), s = u.openCursor(), c = 1;
                  s.onsuccess = function() {
                    var d = s.result;
                    if (d) {
                      var m = d.value;
                      _e(m) && (m = J(m));
                      var g = e(m, d.key, c++);
                      g !== void 0 ? a(g) : d.continue();
                    } else
                      a();
                  }, s.onerror = function() {
                    t(s.error);
                  };
                } catch (d) {
                  t(d);
                }
              });
            }).catch(t);
          });
          return h(o, n), o;
        }
        function Xe(e, n, r) {
          var o = this;
          e = A(e);
          var a = new v(function(t, i) {
            var f;
            o.ready().then(function() {
              return f = o._dbInfo, ie.call(n) === "[object Blob]" ? w(f.db).then(function(u) {
                return u ? n : fe(n);
              }) : n;
            }).then(function(u) {
              K(o._dbInfo, l, function(s, c) {
                if (s)
                  return i(s);
                try {
                  var d = c.objectStore(o._dbInfo.storeName);
                  u === null && (u = void 0);
                  var m = d.put(u, e);
                  c.oncomplete = function() {
                    u === void 0 && (u = null), t(u);
                  }, c.onabort = c.onerror = function() {
                    var g = m.error ? m.error : m.transaction.error;
                    i(g);
                  };
                } catch (g) {
                  i(g);
                }
              });
            }).catch(i);
          });
          return h(a, r), a;
        }
        function je(e, n) {
          var r = this;
          e = A(e);
          var o = new v(function(a, t) {
            r.ready().then(function() {
              K(r._dbInfo, l, function(i, f) {
                if (i)
                  return t(i);
                try {
                  var u = f.objectStore(r._dbInfo.storeName), s = u.delete(e);
                  f.oncomplete = function() {
                    a();
                  }, f.onerror = function() {
                    t(s.error);
                  }, f.onabort = function() {
                    var c = s.error ? s.error : s.transaction.error;
                    t(c);
                  };
                } catch (c) {
                  t(c);
                }
              });
            }).catch(t);
          });
          return h(o, n), o;
        }
        function Je(e) {
          var n = this, r = new v(function(o, a) {
            n.ready().then(function() {
              K(n._dbInfo, l, function(t, i) {
                if (t)
                  return a(t);
                try {
                  var f = i.objectStore(n._dbInfo.storeName), u = f.clear();
                  i.oncomplete = function() {
                    o();
                  }, i.onabort = i.onerror = function() {
                    var s = u.error ? u.error : u.transaction.error;
                    a(s);
                  };
                } catch (s) {
                  a(s);
                }
              });
            }).catch(a);
          });
          return h(r, e), r;
        }
        function qe(e) {
          var n = this, r = new v(function(o, a) {
            n.ready().then(function() {
              K(n._dbInfo, j, function(t, i) {
                if (t)
                  return a(t);
                try {
                  var f = i.objectStore(n._dbInfo.storeName), u = f.count();
                  u.onsuccess = function() {
                    o(u.result);
                  }, u.onerror = function() {
                    a(u.error);
                  };
                } catch (s) {
                  a(s);
                }
              });
            }).catch(a);
          });
          return h(r, e), r;
        }
        function Ze(e, n) {
          var r = this, o = new v(function(a, t) {
            if (e < 0) {
              a(null);
              return;
            }
            r.ready().then(function() {
              K(r._dbInfo, j, function(i, f) {
                if (i)
                  return t(i);
                try {
                  var u = f.objectStore(r._dbInfo.storeName), s = !1, c = u.openKeyCursor();
                  c.onsuccess = function() {
                    var d = c.result;
                    if (!d) {
                      a(null);
                      return;
                    }
                    e === 0 || s ? a(d.key) : (s = !0, d.advance(e));
                  }, c.onerror = function() {
                    t(c.error);
                  };
                } catch (d) {
                  t(d);
                }
              });
            }).catch(t);
          });
          return h(o, n), o;
        }
        function ke(e) {
          var n = this, r = new v(function(o, a) {
            n.ready().then(function() {
              K(n._dbInfo, j, function(t, i) {
                if (t)
                  return a(t);
                try {
                  var f = i.objectStore(n._dbInfo.storeName), u = f.openKeyCursor(), s = [];
                  u.onsuccess = function() {
                    var c = u.result;
                    if (!c) {
                      o(s);
                      return;
                    }
                    s.push(c.key), c.continue();
                  }, u.onerror = function() {
                    a(u.error);
                  };
                } catch (c) {
                  a(c);
                }
              });
            }).catch(a);
          });
          return h(r, e), r;
        }
        function er(e, n) {
          n = W.apply(this, arguments);
          var r = this.config();
          e = typeof e != "function" && e || {}, e.name || (e.name = e.name || r.name, e.storeName = e.storeName || r.storeName);
          var o = this, a;
          if (!e.name)
            a = v.reject("Invalid arguments");
          else {
            var t = e.name === r.name && o._dbInfo.db, i = t ? v.resolve(o._dbInfo.db) : V(e).then(function(f) {
              var u = N[e.name], s = u.forages;
              u.db = f;
              for (var c = 0; c < s.length; c++)
                s[c]._dbInfo.db = f;
              return f;
            });
            e.storeName ? a = i.then(function(f) {
              if (f.objectStoreNames.contains(e.storeName)) {
                var u = f.version + 1;
                x(e);
                var s = N[e.name], c = s.forages;
                f.close();
                for (var d = 0; d < c.length; d++) {
                  var m = c[d];
                  m._dbInfo.db = null, m._dbInfo.version = u;
                }
                var g = new v(function(_, R) {
                  var S = B.open(e.name, u);
                  S.onerror = function(U) {
                    var ee = S.result;
                    ee.close(), R(U);
                  }, S.onupgradeneeded = function() {
                    var U = S.result;
                    U.deleteObjectStore(e.storeName);
                  }, S.onsuccess = function() {
                    var U = S.result;
                    U.close(), _(U);
                  };
                });
                return g.then(function(_) {
                  s.db = _;
                  for (var R = 0; R < c.length; R++) {
                    var S = c[R];
                    S._dbInfo.db = _, O(S._dbInfo);
                  }
                }).catch(function(_) {
                  throw (F(e, _) || v.resolve()).catch(function() {
                  }), _;
                });
              }
            }) : a = i.then(function(f) {
              x(e);
              var u = N[e.name], s = u.forages;
              f.close();
              for (var c = 0; c < s.length; c++) {
                var d = s[c];
                d._dbInfo.db = null;
              }
              var m = new v(function(g, _) {
                var R = B.deleteDatabase(e.name);
                R.onerror = function() {
                  var S = R.result;
                  S && S.close(), _(R.error);
                }, R.onblocked = function() {
                  console.warn('dropInstance blocked for database "' + e.name + '" until all open connections are closed');
                }, R.onsuccess = function() {
                  var S = R.result;
                  S && S.close(), g(S);
                };
              });
              return m.then(function(g) {
                u.db = g;
                for (var _ = 0; _ < s.length; _++) {
                  var R = s[_];
                  O(R._dbInfo);
                }
              }).catch(function(g) {
                throw (F(e, g) || v.resolve()).catch(function() {
                }), g;
              });
            });
          }
          return h(a, n), a;
        }
        var rr = {
          _driver: "asyncStorage",
          _initStorage: Qe,
          _support: T(),
          iterate: He,
          getItem: Ge,
          setItem: Xe,
          removeItem: je,
          clear: Je,
          length: qe,
          key: Ze,
          keys: ke,
          dropInstance: er
        };
        function nr() {
          return typeof openDatabase == "function";
        }
        var G = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", tr = "~~local_forage_type~", we = /^~~local_forage_type~([^~]+)~/, ne = "__lfsc__:", ue = ne.length, se = "arbf", ce = "blob", Ee = "si08", Se = "ui08", Ie = "uic8", Re = "si16", Ae = "si32", De = "ur16", Ne = "ui32", Te = "fl32", xe = "fl64", Be = ue + se.length, Ce = Object.prototype.toString;
        function Oe(e) {
          var n = e.length * 0.75, r = e.length, o, a = 0, t, i, f, u;
          e[e.length - 1] === "=" && (n--, e[e.length - 2] === "=" && n--);
          var s = new ArrayBuffer(n), c = new Uint8Array(s);
          for (o = 0; o < r; o += 4)
            t = G.indexOf(e[o]), i = G.indexOf(e[o + 1]), f = G.indexOf(e[o + 2]), u = G.indexOf(e[o + 3]), c[a++] = t << 2 | i >> 4, c[a++] = (i & 15) << 4 | f >> 2, c[a++] = (f & 3) << 6 | u & 63;
          return s;
        }
        function le(e) {
          var n = new Uint8Array(e), r = "", o;
          for (o = 0; o < n.length; o += 3)
            r += G[n[o] >> 2], r += G[(n[o] & 3) << 4 | n[o + 1] >> 4], r += G[(n[o + 1] & 15) << 2 | n[o + 2] >> 6], r += G[n[o + 2] & 63];
          return n.length % 3 === 2 ? r = r.substring(0, r.length - 1) + "=" : n.length % 3 === 1 && (r = r.substring(0, r.length - 2) + "=="), r;
        }
        function or(e, n) {
          var r = "";
          if (e && (r = Ce.call(e)), e && (r === "[object ArrayBuffer]" || e.buffer && Ce.call(e.buffer) === "[object ArrayBuffer]")) {
            var o, a = ne;
            e instanceof ArrayBuffer ? (o = e, a += se) : (o = e.buffer, r === "[object Int8Array]" ? a += Ee : r === "[object Uint8Array]" ? a += Se : r === "[object Uint8ClampedArray]" ? a += Ie : r === "[object Int16Array]" ? a += Re : r === "[object Uint16Array]" ? a += De : r === "[object Int32Array]" ? a += Ae : r === "[object Uint32Array]" ? a += Ne : r === "[object Float32Array]" ? a += Te : r === "[object Float64Array]" ? a += xe : n(new Error("Failed to get type for BinaryArray"))), n(a + le(o));
          } else if (r === "[object Blob]") {
            var t = new FileReader();
            t.onload = function() {
              var i = tr + e.type + "~" + le(this.result);
              n(ne + ce + i);
            }, t.readAsArrayBuffer(e);
          } else
            try {
              n(JSON.stringify(e));
            } catch (i) {
              console.error("Couldn't convert value into a JSON string: ", e), n(null, i);
            }
        }
        function ar(e) {
          if (e.substring(0, ue) !== ne)
            return JSON.parse(e);
          var n = e.substring(Be), r = e.substring(ue, Be), o;
          if (r === ce && we.test(n)) {
            var a = n.match(we);
            o = a[1], n = n.substring(a[0].length);
          }
          var t = Oe(n);
          switch (r) {
            case se:
              return t;
            case ce:
              return z([t], { type: o });
            case Ee:
              return new Int8Array(t);
            case Se:
              return new Uint8Array(t);
            case Ie:
              return new Uint8ClampedArray(t);
            case Re:
              return new Int16Array(t);
            case De:
              return new Uint16Array(t);
            case Ae:
              return new Int32Array(t);
            case Ne:
              return new Uint32Array(t);
            case Te:
              return new Float32Array(t);
            case xe:
              return new Float64Array(t);
            default:
              throw new Error("Unkown type: " + r);
          }
        }
        var ve = {
          serialize: or,
          deserialize: ar,
          stringToBuffer: Oe,
          bufferToString: le
        };
        function Le(e, n, r, o) {
          e.executeSql("CREATE TABLE IF NOT EXISTS " + n.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], r, o);
        }
        function ir(e) {
          var n = this, r = {
            db: null
          };
          if (e)
            for (var o in e)
              r[o] = typeof e[o] != "string" ? e[o].toString() : e[o];
          var a = new v(function(t, i) {
            try {
              r.db = openDatabase(r.name, String(r.version), r.description, r.size);
            } catch (f) {
              return i(f);
            }
            r.db.transaction(function(f) {
              Le(f, r, function() {
                n._dbInfo = r, t();
              }, function(u, s) {
                i(s);
              });
            }, i);
          });
          return r.serializer = ve, a;
        }
        function H(e, n, r, o, a, t) {
          e.executeSql(r, o, a, function(i, f) {
            f.code === f.SYNTAX_ERR ? i.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [n.storeName], function(u, s) {
              s.rows.length ? t(u, f) : Le(u, n, function() {
                u.executeSql(r, o, a, t);
              }, t);
            }, t) : t(i, f);
          }, t);
        }
        function fr(e, n) {
          var r = this;
          e = A(e);
          var o = new v(function(a, t) {
            r.ready().then(function() {
              var i = r._dbInfo;
              i.db.transaction(function(f) {
                H(f, i, "SELECT * FROM " + i.storeName + " WHERE key = ? LIMIT 1", [e], function(u, s) {
                  var c = s.rows.length ? s.rows.item(0).value : null;
                  c && (c = i.serializer.deserialize(c)), a(c);
                }, function(u, s) {
                  t(s);
                });
              });
            }).catch(t);
          });
          return h(o, n), o;
        }
        function ur(e, n) {
          var r = this, o = new v(function(a, t) {
            r.ready().then(function() {
              var i = r._dbInfo;
              i.db.transaction(function(f) {
                H(f, i, "SELECT * FROM " + i.storeName, [], function(u, s) {
                  for (var c = s.rows, d = c.length, m = 0; m < d; m++) {
                    var g = c.item(m), _ = g.value;
                    if (_ && (_ = i.serializer.deserialize(_)), _ = e(_, g.key, m + 1), _ !== void 0) {
                      a(_);
                      return;
                    }
                  }
                  a();
                }, function(u, s) {
                  t(s);
                });
              });
            }).catch(t);
          });
          return h(o, n), o;
        }
        function Pe(e, n, r, o) {
          var a = this;
          e = A(e);
          var t = new v(function(i, f) {
            a.ready().then(function() {
              n === void 0 && (n = null);
              var u = n, s = a._dbInfo;
              s.serializer.serialize(n, function(c, d) {
                d ? f(d) : s.db.transaction(function(m) {
                  H(m, s, "INSERT OR REPLACE INTO " + s.storeName + " (key, value) VALUES (?, ?)", [e, c], function() {
                    i(u);
                  }, function(g, _) {
                    f(_);
                  });
                }, function(m) {
                  if (m.code === m.QUOTA_ERR) {
                    if (o > 0) {
                      i(Pe.apply(a, [e, u, r, o - 1]));
                      return;
                    }
                    f(m);
                  }
                });
              });
            }).catch(f);
          });
          return h(t, r), t;
        }
        function sr(e, n, r) {
          return Pe.apply(this, [e, n, r, 1]);
        }
        function cr(e, n) {
          var r = this;
          e = A(e);
          var o = new v(function(a, t) {
            r.ready().then(function() {
              var i = r._dbInfo;
              i.db.transaction(function(f) {
                H(f, i, "DELETE FROM " + i.storeName + " WHERE key = ?", [e], function() {
                  a();
                }, function(u, s) {
                  t(s);
                });
              });
            }).catch(t);
          });
          return h(o, n), o;
        }
        function lr(e) {
          var n = this, r = new v(function(o, a) {
            n.ready().then(function() {
              var t = n._dbInfo;
              t.db.transaction(function(i) {
                H(i, t, "DELETE FROM " + t.storeName, [], function() {
                  o();
                }, function(f, u) {
                  a(u);
                });
              });
            }).catch(a);
          });
          return h(r, e), r;
        }
        function vr(e) {
          var n = this, r = new v(function(o, a) {
            n.ready().then(function() {
              var t = n._dbInfo;
              t.db.transaction(function(i) {
                H(i, t, "SELECT COUNT(key) as c FROM " + t.storeName, [], function(f, u) {
                  var s = u.rows.item(0).c;
                  o(s);
                }, function(f, u) {
                  a(u);
                });
              });
            }).catch(a);
          });
          return h(r, e), r;
        }
        function dr(e, n) {
          var r = this, o = new v(function(a, t) {
            r.ready().then(function() {
              var i = r._dbInfo;
              i.db.transaction(function(f) {
                H(f, i, "SELECT key FROM " + i.storeName + " WHERE id = ? LIMIT 1", [e + 1], function(u, s) {
                  var c = s.rows.length ? s.rows.item(0).key : null;
                  a(c);
                }, function(u, s) {
                  t(s);
                });
              });
            }).catch(t);
          });
          return h(o, n), o;
        }
        function hr(e) {
          var n = this, r = new v(function(o, a) {
            n.ready().then(function() {
              var t = n._dbInfo;
              t.db.transaction(function(i) {
                H(i, t, "SELECT key FROM " + t.storeName, [], function(f, u) {
                  for (var s = [], c = 0; c < u.rows.length; c++)
                    s.push(u.rows.item(c).key);
                  o(s);
                }, function(f, u) {
                  a(u);
                });
              });
            }).catch(a);
          });
          return h(r, e), r;
        }
        function mr(e) {
          return new v(function(n, r) {
            e.transaction(function(o) {
              o.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(a, t) {
                for (var i = [], f = 0; f < t.rows.length; f++)
                  i.push(t.rows.item(f).name);
                n({
                  db: e,
                  storeNames: i
                });
              }, function(a, t) {
                r(t);
              });
            }, function(o) {
              r(o);
            });
          });
        }
        function yr(e, n) {
          n = W.apply(this, arguments);
          var r = this.config();
          e = typeof e != "function" && e || {}, e.name || (e.name = e.name || r.name, e.storeName = e.storeName || r.storeName);
          var o = this, a;
          return e.name ? a = new v(function(t) {
            var i;
            e.name === r.name ? i = o._dbInfo.db : i = openDatabase(e.name, "", "", 0), e.storeName ? t({
              db: i,
              storeNames: [e.storeName]
            }) : t(mr(i));
          }).then(function(t) {
            return new v(function(i, f) {
              t.db.transaction(function(u) {
                function s(g) {
                  return new v(function(_, R) {
                    u.executeSql("DROP TABLE IF EXISTS " + g, [], function() {
                      _();
                    }, function(S, U) {
                      R(U);
                    });
                  });
                }
                for (var c = [], d = 0, m = t.storeNames.length; d < m; d++)
                  c.push(s(t.storeNames[d]));
                v.all(c).then(function() {
                  i();
                }).catch(function(g) {
                  f(g);
                });
              }, function(u) {
                f(u);
              });
            });
          }) : a = v.reject("Invalid arguments"), h(a, n), a;
        }
        var pr = {
          _driver: "webSQLStorage",
          _initStorage: ir,
          _support: nr(),
          iterate: ur,
          getItem: fr,
          setItem: sr,
          removeItem: cr,
          clear: lr,
          length: vr,
          key: dr,
          keys: hr,
          dropInstance: yr
        };
        function gr() {
          try {
            return typeof localStorage < "u" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
            !!localStorage.setItem;
          } catch {
            return !1;
          }
        }
        function Fe(e, n) {
          var r = e.name + "/";
          return e.storeName !== n.storeName && (r += e.storeName + "/"), r;
        }
        function _r() {
          var e = "_localforage_support_test";
          try {
            return localStorage.setItem(e, !0), localStorage.removeItem(e), !1;
          } catch {
            return !0;
          }
        }
        function br() {
          return !_r() || localStorage.length > 0;
        }
        function wr(e) {
          var n = this, r = {};
          if (e)
            for (var o in e)
              r[o] = e[o];
          return r.keyPrefix = Fe(e, n._defaultConfig), br() ? (n._dbInfo = r, r.serializer = ve, v.resolve()) : v.reject();
        }
        function Er(e) {
          var n = this, r = n.ready().then(function() {
            for (var o = n._dbInfo.keyPrefix, a = localStorage.length - 1; a >= 0; a--) {
              var t = localStorage.key(a);
              t.indexOf(o) === 0 && localStorage.removeItem(t);
            }
          });
          return h(r, e), r;
        }
        function Sr(e, n) {
          var r = this;
          e = A(e);
          var o = r.ready().then(function() {
            var a = r._dbInfo, t = localStorage.getItem(a.keyPrefix + e);
            return t && (t = a.serializer.deserialize(t)), t;
          });
          return h(o, n), o;
        }
        function Ir(e, n) {
          var r = this, o = r.ready().then(function() {
            for (var a = r._dbInfo, t = a.keyPrefix, i = t.length, f = localStorage.length, u = 1, s = 0; s < f; s++) {
              var c = localStorage.key(s);
              if (c.indexOf(t) === 0) {
                var d = localStorage.getItem(c);
                if (d && (d = a.serializer.deserialize(d)), d = e(d, c.substring(i), u++), d !== void 0)
                  return d;
              }
            }
          });
          return h(o, n), o;
        }
        function Rr(e, n) {
          var r = this, o = r.ready().then(function() {
            var a = r._dbInfo, t;
            try {
              t = localStorage.key(e);
            } catch {
              t = null;
            }
            return t && (t = t.substring(a.keyPrefix.length)), t;
          });
          return h(o, n), o;
        }
        function Ar(e) {
          var n = this, r = n.ready().then(function() {
            for (var o = n._dbInfo, a = localStorage.length, t = [], i = 0; i < a; i++) {
              var f = localStorage.key(i);
              f.indexOf(o.keyPrefix) === 0 && t.push(f.substring(o.keyPrefix.length));
            }
            return t;
          });
          return h(r, e), r;
        }
        function Dr(e) {
          var n = this, r = n.keys().then(function(o) {
            return o.length;
          });
          return h(r, e), r;
        }
        function Nr(e, n) {
          var r = this;
          e = A(e);
          var o = r.ready().then(function() {
            var a = r._dbInfo;
            localStorage.removeItem(a.keyPrefix + e);
          });
          return h(o, n), o;
        }
        function Tr(e, n, r) {
          var o = this;
          e = A(e);
          var a = o.ready().then(function() {
            n === void 0 && (n = null);
            var t = n;
            return new v(function(i, f) {
              var u = o._dbInfo;
              u.serializer.serialize(n, function(s, c) {
                if (c)
                  f(c);
                else
                  try {
                    localStorage.setItem(u.keyPrefix + e, s), i(t);
                  } catch (d) {
                    (d.name === "QuotaExceededError" || d.name === "NS_ERROR_DOM_QUOTA_REACHED") && f(d), f(d);
                  }
              });
            });
          });
          return h(a, r), a;
        }
        function xr(e, n) {
          if (n = W.apply(this, arguments), e = typeof e != "function" && e || {}, !e.name) {
            var r = this.config();
            e.name = e.name || r.name, e.storeName = e.storeName || r.storeName;
          }
          var o = this, a;
          return e.name ? a = new v(function(t) {
            e.storeName ? t(Fe(e, o._defaultConfig)) : t(e.name + "/");
          }).then(function(t) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
              var f = localStorage.key(i);
              f.indexOf(t) === 0 && localStorage.removeItem(f);
            }
          }) : a = v.reject("Invalid arguments"), h(a, n), a;
        }
        var Br = {
          _driver: "localStorageWrapper",
          _initStorage: wr,
          _support: gr(),
          iterate: Ir,
          getItem: Sr,
          setItem: Tr,
          removeItem: Nr,
          clear: Er,
          length: Dr,
          key: Rr,
          keys: Ar,
          dropInstance: xr
        }, Cr = function(n, r) {
          return n === r || typeof n == "number" && typeof r == "number" && isNaN(n) && isNaN(r);
        }, Or = function(n, r) {
          for (var o = n.length, a = 0; a < o; ) {
            if (Cr(n[a], r))
              return !0;
            a++;
          }
          return !1;
        }, Me = Array.isArray || function(e) {
          return Object.prototype.toString.call(e) === "[object Array]";
        }, k = {}, Ue = {}, q = {
          INDEXEDDB: rr,
          WEBSQL: pr,
          LOCALSTORAGE: Br
        }, Lr = [q.INDEXEDDB._driver, q.WEBSQL._driver, q.LOCALSTORAGE._driver], te = ["dropInstance"], de = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(te), Pr = {
          description: "",
          driver: Lr.slice(),
          name: "localforage",
          // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
          // we can use without a prompt.
          size: 4980736,
          storeName: "keyvaluepairs",
          version: 1
        };
        function Fr(e, n) {
          e[n] = function() {
            var r = arguments;
            return e.ready().then(function() {
              return e[n].apply(e, r);
            });
          };
        }
        function he() {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            if (n)
              for (var r in n)
                n.hasOwnProperty(r) && (Me(n[r]) ? arguments[0][r] = n[r].slice() : arguments[0][r] = n[r]);
          }
          return arguments[0];
        }
        var Mr = function() {
          function e(n) {
            C(this, e);
            for (var r in q)
              if (q.hasOwnProperty(r)) {
                var o = q[r], a = o._driver;
                this[r] = a, k[a] || this.defineDriver(o);
              }
            this._defaultConfig = he({}, Pr), this._config = he({}, this._defaultConfig, n), this._driverSet = null, this._initDriver = null, this._ready = !1, this._dbInfo = null, this._wrapLibraryMethodsWithReady(), this.setDriver(this._config.driver).catch(function() {
            });
          }
          return e.prototype.config = function(r) {
            if ((typeof r > "u" ? "undefined" : E(r)) === "object") {
              if (this._ready)
                return new Error("Can't call config() after localforage has been used.");
              for (var o in r) {
                if (o === "storeName" && (r[o] = r[o].replace(/\\W/g, "_")), o === "version" && typeof r[o] != "number")
                  return new Error("Database version must be a number.");
                this._config[o] = r[o];
              }
              return "driver" in r && r.driver ? this.setDriver(this._config.driver) : !0;
            } else return typeof r == "string" ? this._config[r] : this._config;
          }, e.prototype.defineDriver = function(r, o, a) {
            var t = new v(function(i, f) {
              try {
                var u = r._driver, s = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                if (!r._driver) {
                  f(s);
                  return;
                }
                for (var c = de.concat("_initStorage"), d = 0, m = c.length; d < m; d++) {
                  var g = c[d], _ = !Or(te, g);
                  if ((_ || r[g]) && typeof r[g] != "function") {
                    f(s);
                    return;
                  }
                }
                var R = function() {
                  for (var ee = function(zr) {
                    return function() {
                      var Wr = new Error("Method " + zr + " is not implemented by the current driver"), Ye = v.reject(Wr);
                      return h(Ye, arguments[arguments.length - 1]), Ye;
                    };
                  }, me = 0, Yr = te.length; me < Yr; me++) {
                    var ye = te[me];
                    r[ye] || (r[ye] = ee(ye));
                  }
                };
                R();
                var S = function(ee) {
                  k[u] && console.info("Redefining LocalForage driver: " + u), k[u] = r, Ue[u] = ee, i();
                };
                "_support" in r ? r._support && typeof r._support == "function" ? r._support().then(S, f) : S(!!r._support) : S(!0);
              } catch (U) {
                f(U);
              }
            });
            return I(t, o, a), t;
          }, e.prototype.driver = function() {
            return this._driver || null;
          }, e.prototype.getDriver = function(r, o, a) {
            var t = k[r] ? v.resolve(k[r]) : v.reject(new Error("Driver not found."));
            return I(t, o, a), t;
          }, e.prototype.getSerializer = function(r) {
            var o = v.resolve(ve);
            return I(o, r), o;
          }, e.prototype.ready = function(r) {
            var o = this, a = o._driverSet.then(function() {
              return o._ready === null && (o._ready = o._initDriver()), o._ready;
            });
            return I(a, r, r), a;
          }, e.prototype.setDriver = function(r, o, a) {
            var t = this;
            Me(r) || (r = [r]);
            var i = this._getSupportedDrivers(r);
            function f() {
              t._config.driver = t.driver();
            }
            function u(d) {
              return t._extend(d), f(), t._ready = t._initStorage(t._config), t._ready;
            }
            function s(d) {
              return function() {
                var m = 0;
                function g() {
                  for (; m < d.length; ) {
                    var _ = d[m];
                    return m++, t._dbInfo = null, t._ready = null, t.getDriver(_).then(u).catch(g);
                  }
                  f();
                  var R = new Error("No available storage method found.");
                  return t._driverSet = v.reject(R), t._driverSet;
                }
                return g();
              };
            }
            var c = this._driverSet !== null ? this._driverSet.catch(function() {
              return v.resolve();
            }) : v.resolve();
            return this._driverSet = c.then(function() {
              var d = i[0];
              return t._dbInfo = null, t._ready = null, t.getDriver(d).then(function(m) {
                t._driver = m._driver, f(), t._wrapLibraryMethodsWithReady(), t._initDriver = s(i);
              });
            }).catch(function() {
              f();
              var d = new Error("No available storage method found.");
              return t._driverSet = v.reject(d), t._driverSet;
            }), I(this._driverSet, o, a), this._driverSet;
          }, e.prototype.supports = function(r) {
            return !!Ue[r];
          }, e.prototype._extend = function(r) {
            he(this, r);
          }, e.prototype._getSupportedDrivers = function(r) {
            for (var o = [], a = 0, t = r.length; a < t; a++) {
              var i = r[a];
              this.supports(i) && o.push(i);
            }
            return o;
          }, e.prototype._wrapLibraryMethodsWithReady = function() {
            for (var r = 0, o = de.length; r < o; r++)
              Fr(this, de[r]);
          }, e.prototype.createInstance = function(r) {
            return new e(r);
          }, e;
        }(), Ur = new Mr();
        Y.exports = Ur;
      }, { 3: 3 }] }, {}, [4])(4);
    });
  }(pe)), pe.exports;
}
var Kr = Vr(), We = /* @__PURE__ */ $r(Kr);
const ge = We.createInstance({
  driver: We.INDEXEDDB,
  name: "EventProducerDB",
  version: 1
});
let $e = !1;
async function Qr() {
  return await ge.getItem(
    "events",
    (X) => {
      if (X)
        throw console.error("Error in restoring events:", X), X;
    }
  ) ?? void 0;
}
const Gr = async () => {
  $e || (await ge.ready(), $e = !0);
};
self.onmessage = async (L) => {
  const { data: X } = L;
  switch (X.action) {
    case "init": {
      await Gr();
      const P = await Qr();
      self.postMessage({ action: "initSuccess", events: P });
      break;
    }
    case "persist":
      ge.setItem("events", X.events).catch(console.error);
      break;
  }
};
`, x = typeof self < "u" && self.Blob && new Blob(["URL.revokeObjectURL(import.meta.url);", B], { type: "text/javascript;charset=utf-8" });
function H(e) {
  let r;
  try {
    if (r = x && (self.URL || self.webkitURL).createObjectURL(x), !r) throw "";
    const t = new Worker(r, {
      type: "module",
      name: e?.name
    });
    return t.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(r);
    }), t;
  } catch {
    return new Worker(
      "data:text/javascript;charset=utf-8," + encodeURIComponent(B),
      {
        type: "module",
        name: e?.name
      }
    );
  }
}
if (!window.Worker)
  throw new Error("Web Workers are not supported in this browser");
const C = new H();
let b = [];
function w() {
  return b;
}
function J() {
  const e = w();
  return e.length >= 10 ? e.slice(0, 10) : e;
}
function j(e) {
  b = e;
}
const Y = (e) => new Promise((r, t) => {
  C.addEventListener("message", (n) => {
    const { data: o } = n;
    switch (o.action) {
      case "initSuccess": {
        if (o.events) {
          const i = e?.feralEventTypes ?? [], a = i.length > 0 ? o.events.filter((v) => !i.includes(v.name)) : o.events;
          j(w().concat(a));
        }
        r();
        break;
      }
      default:
        console.error("Unknown action:", n), t(new Error("Unknown action"));
    }
  }), C.postMessage({ action: "init" });
});
function A() {
  C.postMessage({ action: "persist", events: w() });
}
function Q(e) {
  b = b.filter((r) => !e.includes(r.id)), A();
}
function G(e) {
  b.push(e), A();
}
const k = ({
  appInfo: { appName: e, appVersion: r },
  authorize: t = !0,
  consentCategory: n,
  credentials: o,
  platformData: { browserName: i, browserVersion: a, osName: v },
  sentTimestamp: h,
  suppliedHeaders: l
}) => {
  const d = o?.token, s = o?.clientId ?? "clientIDMissing!", u = {
    "app-name": e,
    "app-version": r,
    "browser-name": i,
    "browser-version": a,
    "client-id": s,
    "consent-category": n,
    "os-name": v,
    "requested-sent-timestamp": h
  };
  return t && d && (u.authorization = d), l && Object.entries(l).forEach(([p, c]) => {
    u[p] = c;
  }), u;
};
function P(e) {
  const r = new URLSearchParams();
  return e.forEach((t, n) => {
    const i = `SendMessageBatchRequestEntry.${n + 1}`, a = `${i}.MessageAttribute`;
    r.append(`${i}.Id`, t.id), r.append(
      `${i}.MessageBody`,
      typeof t.payload == "string" ? t.payload : JSON.stringify(t.payload)
    ), r.append(`${a}.1.Name`, "Name"), r.append(`${a}.1.Value.StringValue`, t.name), r.append(`${a}.1.Value.DataType`, "String"), t.headers && (r.append(`${a}.2.Name`, "Headers"), r.append(`${a}.2.Value.DataType`, "String"), r.append(
      `${a}.2.Value.StringValue`,
      JSON.stringify(t.headers)
    ));
  }), r;
}
let E = typeof globalThis?.crypto?.randomUUID == "function";
const X = () => globalThis.crypto?.randomUUID();
let F = E ? X : () => {
  if (!E)
    throw new Error(
      "Uuid not initialized; run await init(); before using uuid."
    );
  return "UUID_NOT_INITIALIZED";
};
async function Z() {
  if (!E) {
    const { nanoid: e } = await import("./index.browser-CvC356_9.js");
    F = () => e();
  }
  E = !0;
}
const M = () => F();
let f = {
  consentFilteredEvents: {},
  storingFailedEvents: {},
  validationFailedEvents: {}
};
const ee = () => {
  f.consentFilteredEvents = {}, f.storingFailedEvents = {}, f.validationFailedEvents = {};
}, L = ({
  eventName: e,
  reason: r
}) => {
  const t = f[r][e] ?? 0;
  f[r][e] = t + 1;
}, re = () => Object.keys(f.consentFilteredEvents).length + Object.keys(f.storingFailedEvents).length + Object.keys(f.validationFailedEvents).length > 0, te = async () => {
  if (re()) {
    const e = S();
    if (!e.credentialsProvider)
      throw new Error("CredentialsProvider not set");
    const r = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    }), t = {
      headers: k({
        appInfo: e.appInfo,
        authorize: !1,
        consentCategory: "NECESSARY",
        credentials: await e.credentialsProvider?.getCredentials(),
        platformData: e.platform,
        sentTimestamp: O.now()
      }),
      id: M(),
      name: "tep-tl-monitoring",
      payload: JSON.stringify(f)
    };
    globalThis.__tepTlDebug?.debug && console.log("monitoringEvent sent:", t);
    const n = P([t]);
    fetch(e.tlPublicConsumerUri, {
      body: n,
      headers: r,
      method: "post"
    }).catch(console.error), ee();
  }
  return Promise.resolve();
}, U = async ({
  config: e
}) => {
  const r = J();
  if (r.length === 0)
    return Promise.resolve();
  const t = new Headers({
    "Content-Type": "application/x-www-form-urlencoded"
  });
  if (!e.credentialsProvider)
    return Promise.reject(
      new m("CredentialsProvider not set")
    );
  const o = (await e.credentialsProvider?.getCredentials()).token;
  o && t.set("Authorization", `Bearer ${o}`);
  const i = o ? e.tlConsumerUri : e.tlPublicConsumerUri, a = P(r), v = await fetch(i, {
    body: a,
    headers: t,
    method: "post"
  });
  if (v.ok) {
    q() && T(!1);
    const h = await v.text(), l = new window.DOMParser().parseFromString(h, "text/xml"), d = [];
    if (l.querySelectorAll(
      "SendMessageBatchResponse SendMessageBatchResult SendMessageBatchResultEntry Id"
    ).forEach((s) => {
      s.textContent && d.push(s.textContent);
    }), l.querySelectorAll(
      "SendMessageBatchResponse SendMessageBatchResult BatchResultErrorEntry"
    ).forEach((s) => {
      const u = s.querySelector("Id")?.textContent, p = s.querySelector("SenderFault")?.textContent === "true";
      if (u && p) {
        d.push(u);
        const c = r.find((z) => z.id === u);
        c && L({
          eventName: c.name,
          reason: "validationFailedEvents"
        });
      }
    }), Q(d), w().length > 0)
      return U({ config: e });
  } else {
    const h = await v.text();
    console.error("Error sending event batch:", h), T(!0);
    const l = new window.DOMParser().parseFromString(h, "text/xml");
    if (l.querySelector("ErrorResponse Error Type")?.textContent === "Sender" && l.querySelector("ErrorResponse Error Code")?.textContent === "AWS.SimpleQueueService.BatchEntryIdsNotDistinct") {
      const d = w(), s = {}, u = new Set(
        d.map((c) => (s[c.id] = c, c.id))
      ), p = Array.from(u).map(
        (c) => s[c]
      );
      j(p);
    }
  }
  return Promise.resolve();
}, ne = 30 * 1e3, oe = 60 * 1e3;
let I, N;
const ae = (e) => {
  I && clearInterval(I);
  const r = e?.eventBatchInterval ?? ne;
  I = setInterval(() => {
    U({ config: S() }).catch(console.error);
  }, r), N && clearInterval(N);
  const t = e?.monitoringInterval ?? oe;
  N = setInterval(() => {
    te().catch(console.error);
  }, t);
}, ie = async (e) => {
  V(e), await Promise.all([
    O.synchronize(),
    Z(),
    Y({ feralEventTypes: e.feralEventTypes })
  ]), ae(S());
}, se = new TextEncoder(), ce = (e) => e.isWellFormed ? e.isWellFormed() : !0, ue = (e) => se.encode(e).length < 20480, fe = ({ payload: e, ...r }) => {
  const t = JSON.stringify(r) + e;
  return ue(t) && ce(t);
}, le = ({ event: e, id: r, ts: t }) => {
  const { consentCategory: n, ...o } = e;
  return JSON.stringify({ ...o, ts: t, uuid: r });
}, de = async ({
  config: e,
  credentialsProvider: r,
  event: t
}) => {
  const n = M(), o = O.now();
  return {
    headers: k({
      appInfo: e.appInfo,
      consentCategory: t.consentCategory,
      credentials: await r?.getCredentials(),
      platformData: e.platform,
      sentTimestamp: o,
      suppliedHeaders: t.headers
    }),
    id: n,
    name: t.name,
    payload: le({
      event: t,
      id: n,
      ts: o
    })
  };
}, ve = (e) => {
  if (!e.payload)
    throw new Error(`Event is missing payload!: ${JSON.stringify(e)}`);
  if (!e.name)
    throw new Error(`Event is missing name! ${JSON.stringify(e)}`);
  if (!e.consentCategory)
    throw new Error(
      `Event is missing consentCategory! ${JSON.stringify(e)}`
    );
}, he = async ({
  config: e,
  credentialsProvider: r,
  event: t
}) => {
  if (e.strictMode && ve(t), e.blockedConsentCategories[t.consentCategory])
    return L({
      eventName: t.name,
      reason: "consentFilteredEvents"
    }), Promise.resolve();
  const n = await de({
    config: e,
    credentialsProvider: r,
    event: t
  });
  return fe(n) ? G(n) : Promise.resolve();
}, ge = (e) => {
  const r = S(), { credentialsProvider: t } = r;
  if (t)
    he({
      config: r,
      credentialsProvider: t,
      event: e
    }).catch(console.error);
  else
    throw new m("CredentialsProvider not set");
}, be = (e) => ie(e);
export {
  pe as bus,
  S as getConfig,
  be as init,
  ge as sendEvent,
  me as setConsentCategory,
  ye as setCredentialsProvider
};
